const BASE_APP_URL = "https://test-zy-api.music17.cn";

export default {
  // 钢琴
  subject_4:{
    tutoril:[
      {
        title:"新编钢琴（业余）考级教程",
        tutorial_id:'tutorial_2',
        component:'subject4T2View',
        level:[
          {
            name:'一级',
            content_key:'subject4-t2-1'
          },
          {
            name:'二级',
            content_key:'subject4-t2-2'
          },
          {
            name:'三级',
            content_key:'subject4-t2-3'
          },
          {
              name:'四级',
              content_key:'subject4-t2-4'
          },
          {
              name:'五级',
              content_key:'subject4-t2-5'
          },
          {
              name:'六级',
              content_key:'subject4-t2-6'
          },
          {
              name:'七级',
              content_key:'subject4-t2-7'
          },
          {
            name:'八级',
            content_key:'subject4-t2-8'
          },
          {
            name:'九级',
            content_key:'subject4-t2-9'
          },
          {
            name:'演奏级',
            content_key:'subject4-t2-10'
          }
        ]
        },
      //   {
      //     title:"钢琴（业余）考级教程",
      //     tutorial_id:'tutorial_6',
      //     component:'subject4T6View',
      //     level:[
      //       {
      //         name:'一级',
      //         content_key:'subject4-t6-1'
      //       },
      //       {
      //         name:'二级',
      //         content_key:'subject4-t6-2'
      //       },
      //       {
      //         name:'三级',
      //         content_key:'subject4-t6-3'
      //       },
      //       {
      //         name:'四级',
      //         content_key:'subject4-t6-4'
      //       },
      //       {
      //         name:'五级',
      //         content_key:'subject4-t6-5'
      //       },
      //       {
      //         name:'六级',
      //         content_key:'subject4-t6-6'
      //       },
      //       {
      //         name:'七级',
      //         content_key:'subject4-t6-7'
      //       },
      //       {
      //         name:'八级',
      //         content_key:'subject4-t6-8'
      //       },
      //       {
      //         name:'九级',
      //         content_key:'subject4-t6-9'
      //       }
      //   ]
      // }
    ]
  },
  // 电子琴
  subject_5:{
    tutoril:[
      {
        title:'电子琴（业余）考级教程',
        tutorial_id:'tutorial_14',
        component:'subject5T14View',
          level:[
            {name:'一级',content_key:'subject5-t14-1'},
            {name:'二级',content_key:'subject5-t14-2'},
            {name:'三级',content_key:'subject5-t14-3'},
            {name:'四级',content_key:'subject5-t14-4'},
            {name:'五级',content_key:'subject5-t14-5'},
            {name:'六级',content_key:'subject5-t14-6'},
            {name:'七级',content_key:'subject5-t14-7'},
            {name:'八级',content_key:'subject5-t14-8'},
            {name:'九级',content_key:'subject5-t14-9'},
        ]
      }
    ]
  },
  // 手风琴
  subject_6:{
    tutoril:[
        {
            title:'手风琴（业余）考级教程',
            tutorial_id:'tutorial_13',
            component:'subject6T13View',
            level:[
                {name:'一级',content_key:'subject6-t13-1'},
                {name:'二级',content_key:'subject6-t13-2'},
                {name:'三级',content_key:'subject6-t13-3'},
                {name:'四级',content_key:'subject6-t13-4'},
                {name:'五级',content_key:'subject6-t13-5'},
                {name:'六级',content_key:'subject6-t13-6'},
                {name:'七级',content_key:'subject6-t13-7'},
                {name:'八级',content_key:'subject6-t13-8'},
                {name:'九级',content_key:'subject6-t13-9'},
            ]
        },
        {
            title:'中央音乐学院校外音乐水平考级丛书-手风琴（业余）考级教程',
            tutorial_id:'tutorial_61',
            component:'subject6T61View',
            level:[
                {name:'一级',content_key:'subject6-t61-1'},
                {name:'二级',content_key:'subject6-t61-2'},
                {name:'三级',content_key:'subject6-t61-3'},
                {name:'四级',content_key:'subject6-t61-4'},
                {name:'五级',content_key:'subject6-t61-5'},
            ]
        }
    ]
  },
  // 数码钢琴
  subject_7:{
    tutoril:[
        {
            title:'新编数码钢琴（业余）考级教程',
            tutorial_id:'tutorial_36',
            component:'subject7T36View',
            level:[
                {name:'一级',content_key:'subject7-t36-1'},
                {name:'二级',content_key:'subject7-t36-2'},
                {name:'三级',content_key:'subject7-t36-3'},
                {name:'四级',content_key:'subject7-t36-4'},
                {name:'五级',content_key:'subject7-t36-5'},
                {name:'六级',content_key:'subject7-t36-6'},
                {name:'七级',content_key:'subject7-t36-7'},
                {name:'八级',content_key:'subject7-t36-8'},
                {name:'九级',content_key:'subject7-t36-9'},
            ]
        }
    ]
  },
  // 中提琴
  subject_8:{
    tutoril:[
        {
            title:'中提琴（业余）考级教程',
            tutorial_id:'tutorial_22',
            component:'subject8T22View',
            level:[
                {name:'一级',content_key:'subject8-t22-1'},
                {name:'二级',content_key:'subject8-t22-2'},
                {name:'三级',content_key:'subject8-t22-3'},
                {name:'四级',content_key:'subject8-t22-4'},
                {name:'五级',content_key:'subject8-t22-5'},
                {name:'六级',content_key:'subject8-t22-6'},
                {name:'七级',content_key:'subject8-t22-7'},
                {name:'八级',content_key:'subject8-t22-8'},
                {name:'九级',content_key:'subject8-t22-9'},
                {name:'演奏级',content_key:'subject8-t22-10'},
            ]
        }
    ]
  },
  // 长号
  subject_9:{
    tutoril:[
        {
            title:'长号（业余）考级教程',
            tutorial_id:'tutorial_29',
            component:'subject9T29View',
            level:[
                {name:'一级',content_key:'subject9-t29-1'},
                {name:'二级',content_key:'subject9-t29-2'},
                {name:'三级',content_key:'subject9-t29-3'},
                {name:'四级',content_key:'subject9-t29-4'},
                {name:'五级',content_key:'subject9-t29-5'},
                {name:'六级',content_key:'subject9-t29-6'},
                {name:'七级',content_key:'subject9-t29-7'},
                {name:'八级',content_key:'subject9-t29-8'},
                {name:'九级',content_key:'subject9-t29-9'},
                {name:'演奏级',content_key:'subject9-t29-10'},
            ]
        }
    ]
  },
  // 长笛
  subject_10:{
    tutoril:[
        {
            title:'长笛（业余）考级教程',
            tutorial_id:'tutorial_34',
            component:'subject10T34View',
            level:[
                {name:'一级',content_key:'subject10-t34-1'},
                {name:'二级',content_key:'subject10-t34-2'},
                {name:'三级',content_key:'subject10-t34-3'},
                {name:'四级',content_key:'subject10-t34-4'},
                {name:'五级',content_key:'subject10-t34-5'},
                {name:'六级',content_key:'subject10-t34-6'},
                {name:'七级',content_key:'subject10-t34-7'},
                {name:'八级',content_key:'subject10-t34-8'},
                {name:'九级',content_key:'subject10-t34-9'},
            ]
        }
    ]
  },
  // 圆号
  subject_11:{
    tutoril:[
        // {
        //     title:'圆号（业余）考级教程',
        //     tutorial_id:'tutorial_30',
        //     component:'subject11T30View',
        //     level:[
        //         {name:'一级',content_key:'subject11-t30-1'},
        //         {name:'二级',content_key:'subject11-t30-2'},
        //         {name:'三级',content_key:'subject11-t30-3'},
        //         {name:'四级',content_key:'subject11-t30-4'},
        //         {name:'五级',content_key:'subject11-t30-5'},
        //         {name:'六级',content_key:'subject11-t30-6'},
        //         {name:'七级',content_key:'subject11-t30-7'},
        //         {name:'八级',content_key:'subject11-t30-8'},
        //         {name:'九级',content_key:'subject11-t30-9'},
        //     ]
        // },
        {
            title:'新编圆号（业余）考级教程',
            tutorial_id:'tutorial_48',
            component:'subject11T48View',
            level:[
                {name:'一级',content_key:'subject11-t48-1'},
                {name:'二级',content_key:'subject11-t48-2'},
                {name:'三级',content_key:'subject11-t48-3'},
                {name:'四级',content_key:'subject11-t48-4'},
                {name:'五级',content_key:'subject11-t48-5'},
                {name:'六级',content_key:'subject11-t48-6'},
                {name:'七级',content_key:'subject11-t48-7'},
                {name:'八级',content_key:'subject11-t48-8'},
                {name:'九级',content_key:'subject11-t48-9'},
                {name:'演奏级',content_key:'subject11-t48-10'},
            ]
        }
    ]
  },
  // 小提琴
  subject_12:{
    tutoril:[
          {
            title:'中央音乐学院校外音乐水平考级曲目-小提琴',
            tutorial_id:'tutorial_49',
            component:'subject12T49View',
            level:[
                {name:'一级',content_key:'subject12-t49-1'},
                {name:'二级',content_key:'subject12-t49-2'},
                {name:'三级',content_key:'subject12-t49-3'},
                {name:'四级',content_key:'subject12-t49-4'},
                {name:'五级',content_key:'subject12-t49-5'},
                {name:'六级',content_key:'subject12-t49-6'},
                {name:'七级',content_key:'subject12-t49-7'},
                {name:'八级',content_key:'subject12-t49-8'},
                {name:'九级',content_key:'subject12-t49-9'},
            ]
        },
        {
            title:'新编小提琴（业余）考级教程',
            tutorial_id:'tutorial_8',
            component:'subject12T8View',
            level:[
                {name:'一级',content_key:'subject12-t8-1'},
                {name:'二级',content_key:'subject12-t8-2'},
                {name:'三级',content_key:'subject12-t8-3'},
                {name:'四级',content_key:'subject12-t8-4'},
                {name:'五级',content_key:'subject12-t8-5'},
                {name:'六级',content_key:'subject12-t8-6'},
                {name:'七级',content_key:'subject12-t8-7'},
                {name:'八级',content_key:'subject12-t8-8'},
                {name:'九级',content_key:'subject12-t8-9'},
                {name:'演奏级',content_key:'subject12-t8-10'},
            ]
        },
        // {
        //     title:'小提琴（业余）考级教程',
        //     tutorial_id:'tutorial_9',
        //     component:'subject12T9View',
        //     level:[
        //         {name:'一级',content_key:'subject12-t9-1'},
        //         {name:'二级',content_key:'subject12-t9-2'},
        //         {name:'三级',content_key:'subject12-t9-3'},
        //         {name:'四级',content_key:'subject12-t9-4'},
        //         {name:'五级',content_key:'subject12-t9-5'},
        //         {name:'六级',content_key:'subject12-t9-6'},
        //         {name:'七级',content_key:'subject12-t9-7'},
        //         {name:'八级',content_key:'subject12-t9-8'},
        //         {name:'九级',content_key:'subject12-t9-9'},
        //     ]
        // },
    ]
  },
  // 小号
  subject_13:{
    tutoril:[
        {
            title:'小号（业余）考级教程',
            tutorial_id:'tutorial_28',
            component:'subject13T28View',
            level:[
                {name:'一级',content_key:'subject13-t28-1'},
                {name:'二级',content_key:'subject13-t28-2'},
                {name:'三级',content_key:'subject13-t28-3'},
                {name:'四级',content_key:'subject13-t28-4'},
                {name:'五级',content_key:'subject13-t28-5'},
                {name:'六级',content_key:'subject13-t28-6'},
                {name:'七级',content_key:'subject13-t28-7'},
                {name:'八级',content_key:'subject13-t28-8'},
                {name:'九级',content_key:'subject13-t28-9'},
                {name:'演奏级',content_key:'subject13-t28-10'},
            ]
        },
        {
            title:'新编小号（业余）考级教程',
            tutorial_id:'tutorial_63',
            component:'subject13T63View',
            level:[
                {name:'一级',content_key:'subject13-t63-1'},
                {name:'二级',content_key:'subject13-t63-2'},
                {name:'三级',content_key:'subject13-t63-3'},
                {name:'四级',content_key:'subject13-t63-4'},
                {name:'五级',content_key:'subject13-t63-5'},
                {name:'六级',content_key:'subject13-t63-6'},
                {name:'七级',content_key:'subject13-t63-7'},
                {name:'八级',content_key:'subject13-t63-8'},
                {name:'九级',content_key:'subject13-t63-9'},
                {name:'演奏级',content_key:'subject13-t63-10'},
            ]
        }
    ]
  },
  // 小鼓
  subject_14:{
    tutoril:[
        {
            title:'小鼓（业余）考级教程',
            tutorial_id:'tutorial_38',
            component:'subject14T38View',
            level:[
                {name:'一级',content_key:'subject14-t38-1'},
                {name:'二级',content_key:'subject14-t38-2'},
                {name:'三级',content_key:'subject14-t38-3'},
                {name:'四级',content_key:'subject14-t38-4'},
                {name:'五级',content_key:'subject14-t38-5'},
                {name:'六级',content_key:'subject14-t38-6'},
                {name:'七级',content_key:'subject14-t38-7'},
                {name:'八级',content_key:'subject14-t38-8'},
                {name:'九级',content_key:'subject14-t38-9'},
            ]
        },
        {
            title:'小军鼓考级（内部教材）',
            tutorial_id:'tutorial_46',
            component:'subject14T46View',
            level:[
                {name:'一级',content_key:'subject14-t46-1'},
                {name:'二级',content_key:'subject14-t46-2'},
                {name:'三级',content_key:'subject14-t46-3'},
                {name:'四级',content_key:'subject14-t46-4'},
                {name:'五级',content_key:'subject14-t46-5'},
                {name:'六级',content_key:'subject14-t46-6'},
                {name:'七级',content_key:'subject14-t46-7'},
                {name:'八级',content_key:'subject14-t46-8'},
                {name:'九级',content_key:'subject14-t46-9'},
            ]
        }
    ]
  },
  // 双簧管
  subject_15:{
    tutoril:[
        {
            title:'双簧管（业余）考级教程',
            tutorial_id:'tutorial_25',
            component:'subject15T25View',
            level:[
                {name:'一级',content_key:'subject15-t25-1'},
                {name:'二级',content_key:'subject15-t25-2'},
                {name:'三级',content_key:'subject15-t25-3'},
                {name:'四级',content_key:'subject15-t25-4'},
                {name:'五级',content_key:'subject15-t25-5'},
                {name:'六级',content_key:'subject15-t25-6'},
                {name:'七级',content_key:'subject15-t25-7'},
                {name:'八级',content_key:'subject15-t25-8'},
                {name:'九级',content_key:'subject15-t25-9'},
            ]
        }
    ]
  },
  // 萨克斯
  subject_16:{
    tutoril:[
        // {
        //     title:'萨克斯（业余）考级教程',
        //     tutorial_id:'tutorial_33',
        //     component:'subject16T33View',
        //     level:[
        //         {name:'一级',content_key:'subject16-t33-1'},
        //         {name:'二级',content_key:'subject16-t33-2'},
        //         {name:'三级',content_key:'subject16-t33-3'},
        //         {name:'四级',content_key:'subject16-t33-4'},
        //         {name:'五级',content_key:'subject16-t33-5'},
        //         {name:'六级',content_key:'subject16-t33-6'},
        //         {name:'七级',content_key:'subject16-t33-7'},
        //         {name:'八级',content_key:'subject16-t33-8'},
        //         {name:'九级',content_key:'subject16-t33-9'},
        //     ]
        // },
        {
            title:'新编萨克斯（业余）考级教程',
            tutorial_id:'tutorial_37',
            component:'subject16T37View',
            level:[
                {name:'一级',content_key:'subject16-t37-1'},
                {name:'二级',content_key:'subject16-t37-2'},
                {name:'三级',content_key:'subject16-t37-3'},
                {name:'四级',content_key:'subject16-t37-4'},
                {name:'五级',content_key:'subject16-t37-5'},
                {name:'六级',content_key:'subject16-t37-6'},
                {name:'七级',content_key:'subject16-t37-7'},
                {name:'八级',content_key:'subject16-t37-8'},
                {name:'九级',content_key:'subject16-t37-9'},
                {name:'演奏级',content_key:'subject16-t37-10'},
            ]
        }
    ]
  },
  // 古典吉他
  subject_17:{
    tutoril:[
        {
            title:'古典吉他（业余）考级教程',
            tutorial_id:'tutorial_26',
            component:'subject17T26View',
            level:[
                {name:'一级',content_key:'subject17-t26-1'},
                {name:'二级',content_key:'subject17-t26-2'},
                {name:'三级',content_key:'subject17-t26-3'},
                {name:'四级',content_key:'subject17-t26-4'},
                {name:'五级',content_key:'subject17-t26-5'},
                {name:'六级',content_key:'subject17-t26-6'},
                {name:'七级',content_key:'subject17-t26-7'},
                {name:'八级',content_key:'subject17-t26-8'},
            ]
        },
        {
            title:'中央音乐学院校外音乐水平考级曲目——古典吉他',
            tutorial_id:'tutorial_67',
            component:'subject17T67View',
            level:[
                {name:'一级',content_key:'subject17-t67-1'},
                {name:'二级',content_key:'subject17-t67-2'},
                {name:'三级',content_key:'subject17-t67-3'},
                {name:'四级',content_key:'subject17-t67-4'},
                {name:'五级',content_key:'subject17-t67-5'},
                {name:'六级',content_key:'subject17-t67-6'},
                {name:'七级',content_key:'subject17-t67-7'},
                {name:'八级',content_key:'subject17-t67-8'},
                {name:'九级',content_key:'subject17-t67-9'},
                {name:'演奏级',content_key:'subject17-t67-10'},
            ]
        }
    ]
  },
  // 低音提琴
  subject_18:{
    tutoril:[
        {
            title:'低音提琴（业余）考级教程',
            tutorial_id:'tutorial_23',
            component:'subject18T23View',
            level:[
                {name:'一级',content_key:'subject18-t23-1'},
                {name:'二级',content_key:'subject18-t23-2'},
                {name:'三级',content_key:'subject18-t23-3'},
                {name:'四级',content_key:'subject18-t23-4'},
                {name:'五级',content_key:'subject18-t23-5'},
                {name:'六级',content_key:'subject18-t23-6'},
                {name:'七级',content_key:'subject18-t23-7'},
                {name:'八级',content_key:'subject18-t23-8'},
                {name:'九级',content_key:'subject18-t23-9'},
            ]
        }
    ]
  },
  // 单簧管
  subject_19:{
    tutoril:[
        // {
        //     title:'单簧管（业余）考级教程',
        //     tutorial_id:'tutorial_24',
        //     component:'subject19T24View',
        //     level:[
        //         {name:'一级',content_key:'subject19-t24-1'},
        //         {name:'二级',content_key:'subject19-t24-2'},
        //         {name:'三级',content_key:'subject19-t24-3'},
        //         {name:'四级',content_key:'subject19-t24-4'},
        //         {name:'五级',content_key:'subject19-t24-5'},
        //         {name:'六级',content_key:'subject19-t24-6'},
        //         {name:'七级',content_key:'subject19-t24-7'},
        //         {name:'八级',content_key:'subject19-t24-8'},
        //         {name:'九级',content_key:'subject19-t24-9'},
        //     ]
        // },
        {
            title:'中央音乐学院校外音乐水平考级曲目-单簧管',
            tutorial_id:'tutorial_47',
            component:'subject19T47View',
            level:[
                {name:'一级',content_key:'subject19-t47-1'},
                {name:'二级',content_key:'subject19-t47-2'},
                {name:'三级',content_key:'subject19-t47-3'},
                {name:'四级',content_key:'subject19-t47-4'},
                {name:'五级',content_key:'subject19-t47-5'},
                {name:'六级',content_key:'subject19-t47-6'},
                {name:'七级',content_key:'subject19-t47-7'},
                {name:'八级',content_key:'subject19-t47-8'},
                {name:'九级',content_key:'subject19-t47-9'},
                {name:'演奏级',content_key:'subject19-t47-10'},
            ]
        }
    ]
  },
  // 大提琴
  subject_20:{
    tutoril:[
        {
            title:'大提琴（业余）考级教程',
            tutorial_id:'tutorial_27',
            component:'subject20T27View',
            level:[
                {name:'一级',content_key:'subject20-t27-1'},
                {name:'二级',content_key:'subject20-t27-2'},
                {name:'三级',content_key:'subject20-t27-3'},
                {name:'四级',content_key:'subject20-t27-4'},
                {name:'五级',content_key:'subject20-t27-5'},
                {name:'六级',content_key:'subject20-t27-6'},
                {name:'七级',content_key:'subject20-t27-7'},
                {name:'八级',content_key:'subject20-t27-8'},
                {name:'九级',content_key:'subject20-t27-9'},
                {name:'演奏级',content_key:'subject20-t27-10'},
            ]
        }
    ]
  },
  // 大管
  subject_21:{
    tutoril:[
        // {
        //     title:'大管（业余）考级教程',
        //     tutorial_id:'tutorial_31',
        //     component:'subject21T31View',
        //     level:[
        //         {name:'一级',content_key:'subject21-t31-1'},
        //         {name:'二级',content_key:'subject21-t31-2'},
        //         {name:'三级',content_key:'subject21-t31-3'},
        //         {name:'四级',content_key:'subject21-t31-4'},
        //         {name:'五级',content_key:'subject21-t31-5'},
        //         {name:'六级',content_key:'subject21-t31-6'},
        //         {name:'七级',content_key:'subject21-t31-7'},
        //         {name:'八级',content_key:'subject21-t31-8'},
        //         {name:'九级',content_key:'subject21-t31-9'},
        //     ]
        // },
        {
            title:'新编大管（业余）考级教程',
            tutorial_id:'tutorial_32',
            component:'subject21T32View',
            level:[
                {name:'一级',content_key:'subject21-t32-1'},
                {name:'二级',content_key:'subject21-t32-2'},
                {name:'三级',content_key:'subject21-t32-3'},
                {name:'四级',content_key:'subject21-t32-4'},
                {name:'五级',content_key:'subject21-t32-5'},
                {name:'六级',content_key:'subject21-t32-6'},
                {name:'七级',content_key:'subject21-t32-7'},
                {name:'八级',content_key:'subject21-t32-8'},
                {name:'九级',content_key:'subject21-t32-9'},
            ]
        }
    ]
  },
  // 中阮
  subject_22:{
    tutoril:[
        {
            title:'中央音乐学院海内外考级曲目——阮',
            tutorial_id:'tutorial_19',
            component:'subject22T19View',
            level:[
                {name:'一级',content_key:'subject22-t19-1'},
                {name:'二级',content_key:'subject22-t19-2'},
                {name:'三级',content_key:'subject22-t19-3'},
                {name:'四级',content_key:'subject22-t19-4'},
                {name:'五级',content_key:'subject22-t19-5'},
                {name:'六级',content_key:'subject22-t19-6'},
                {name:'七级',content_key:'subject22-t19-7'},
                {name:'八级',content_key:'subject22-t19-8'},
                {name:'九级',content_key:'subject22-t19-9'},
                {name:'演奏级',content_key:'subject22-t19-10'},
            ]
        }
    ]
  },
  // 扬琴
  subject_23:{
    tutoril:[
        {
            title:'中央音乐学院海内外考级曲目——扬琴',
            tutorial_id:'tutorial_18',
            component:'subject23T18View',
            level:[
                {name:'一级',content_key:'subject23-t18-1'},
                {name:'二级',content_key:'subject23-t18-2'},
                {name:'三级',content_key:'subject23-t18-3'},
                {name:'四级',content_key:'subject23-t18-4'},
                {name:'五级',content_key:'subject23-t18-5'},
                {name:'六级',content_key:'subject23-t18-6'},
                {name:'七级',content_key:'subject23-t18-7'},
                {name:'八级',content_key:'subject23-t18-8'},
                {name:'九级',content_key:'subject23-t18-9'},
                {name:'演奏级',content_key:'subject23-t18-10'},
            ]
        }
    ]
  },
  // 唢呐
  subject_24:{
    tutoril:[
        {
            title:'中央音乐学院海内外考级曲目——唢呐（海外版）',
            tutorial_id:'tutorial_20',
            component:'subject24T20View',
            level:[
                {name:'一级',content_key:'subject24-t20-1'},
                {name:'二级',content_key:'subject24-t20-2'},
                {name:'三级',content_key:'subject24-t20-3'},
                {name:'四级',content_key:'subject24-t20-4'},
                {name:'五级',content_key:'subject24-t20-5'},
                {name:'六级',content_key:'subject24-t20-6'},
                {name:'七级',content_key:'subject24-t20-7'},
                {name:'八级',content_key:'subject24-t20-8'},
                {name:'九级',content_key:'subject24-t20-9'},
                {name:'演奏级',content_key:'subject24-t20-10'},
            ]
        }
    ]
  },
  // 笙
  subject_25:{
    tutoril:[
        {
            title:'中央音乐学院海内外考级曲目——笙',
            tutorial_id:'tutorial_21',
            component:'subject25T21View',
            level:[
                {name:'一级',content_key:'subject25-t21-1'},
                {name:'二级',content_key:'subject25-t21-2'},
                {name:'三级',content_key:'subject25-t21-3'},
                {name:'四级',content_key:'subject25-t21-4'},
                {name:'五级',content_key:'subject25-t21-5'},
                {name:'六级',content_key:'subject25-t21-6'},
                {name:'七级',content_key:'subject25-t21-7'},
                {name:'八级',content_key:'subject25-t21-8'},
                {name:'九级',content_key:'subject25-t21-9'},
                {name:'演奏级',content_key:'subject25-t21-10'},
            ]
        }
    ]
  },
  // 琵琶
  subject_26:{
    tutoril:[
        {
            title:'中央音乐学院海内外考级曲目——琵琶',
            tutorial_id:'tutorial_17',
            component:'subject26T17View',
            level:[
                {name:'一级',content_key:'subject26-t17-1'},
                {name:'二级',content_key:'subject26-t17-2'},
                {name:'三级',content_key:'subject26-t17-3'},
                {name:'四级',content_key:'subject26-t17-4'},
                {name:'五级',content_key:'subject26-t17-5'},
                {name:'六级',content_key:'subject26-t17-6'},
                {name:'七级',content_key:'subject26-t17-7'},
                {name:'八级',content_key:'subject26-t17-8'},
                {name:'九级',content_key:'subject26-t17-9'},
                {name:'演奏级',content_key:'subject26-t17-10'},
            ]
        }
    ]
  },
  // 古筝
  subject_27:{
    tutoril:[
        {
            title:'中央音乐学院海内外考级曲目——古筝',
            tutorial_id:'tutorial_10',
            component:'subject27T10View',
            level:[
                {name:'一级',content_key:'subject27-t10-1'},
                {name:'二级',content_key:'subject27-t10-2'},
                {name:'三级',content_key:'subject27-t10-3'},
                {name:'四级',content_key:'subject27-t10-4'},
                {name:'五级',content_key:'subject27-t10-5'},
                {name:'六级',content_key:'subject27-t10-6'},
                {name:'七级',content_key:'subject27-t10-7'},
                {name:'八级',content_key:'subject27-t10-8'},
                {name:'九级',content_key:'subject27-t10-9'},
                {name:'演奏级',content_key:'subject27-t10-10'},
            ]
        }
    ]
  },
  // 二胡
  subject_28:{
    tutoril:[
        {
            title:'中央音乐学院海内外考级曲目——二胡',
            tutorial_id:'tutorial_16',
            component:'subject28T16View',
            level:[
                {name:'一级',content_key:'subject28-t16-1'},
                {name:'二级',content_key:'subject28-t16-2'},
                {name:'三级',content_key:'subject28-t16-3'},
                {name:'四级',content_key:'subject28-t16-4'},
                {name:'五级',content_key:'subject28-t16-5'},
                {name:'六级',content_key:'subject28-t16-6'},
                {name:'七级',content_key:'subject28-t16-7'},
                {name:'八级',content_key:'subject28-t16-8'},
                {name:'九级',content_key:'subject28-t16-9'},
                {name:'演奏级',content_key:'subject28-t16-10'},
            ]
        }
    ]
  },
  // 笛子
  subject_29:{
    tutoril:[
        {
            title:'中央音乐学院海内外考级曲目——笛子',
            tutorial_id:'tutorial_15',
            component:'subject29T15View',
            level:[
                {name:'一级',content_key:'subject29-t15-1'},
                {name:'二级',content_key:'subject29-t15-2'},
                {name:'三级',content_key:'subject29-t15-3'},
                {name:'四级',content_key:'subject29-t15-4'},
                {name:'五级',content_key:'subject29-t15-5'},
                {name:'六级',content_key:'subject29-t15-6'},
                {name:'七级',content_key:'subject29-t15-7'},
                {name:'八级',content_key:'subject29-t15-8'},
                {name:'九级',content_key:'subject29-t15-9'},
                {name:'演奏级',content_key:'subject29-t15-10'},
            ]
        }
    ]
  },
  // 少儿音乐
  subject_30:{
    tutoril:[
        {
            title:'新编少儿声乐（业余）考级曲集',
            tutorial_id:'tutorial_45',
            component:'subject30T45View',
            level:[
                {name:'一级',content_key:'subject30-t45-1'},
                {name:'二级',content_key:'subject30-t45-2'},
                {name:'三级',content_key:'subject30-t45-3'},
                {name:'四级',content_key:'subject30-t45-4'},
                {name:'五级',content_key:'subject30-t45-5'},
                {name:'六级',content_key:'subject30-t45-6'},
                {name:'七级',content_key:'subject30-t45-7'},
                {name:'八级',content_key:'subject30-t45-8'},
                {name:'九级',content_key:'subject30-t45-9'},
            ]
        },
        {
            title:'少儿声乐考级曲目（老版曲目单）',
            tutorial_id:'tutorial_11',
            component:'subject30T11View',
            level:[
                // {name:'一级',content_key:'subject30-t11-1'},
                // {name:'二级',content_key:'subject30-t11-2'},
                // {name:'三级',content_key:'subject30-t11-3'},
                // {name:'四级',content_key:'subject30-t11-4'},
                // {name:'五级',content_key:'subject30-t11-5'},
                // {name:'六级',content_key:'subject30-t11-6'},
                // {name:'七级',content_key:'subject30-t11-7'},
                // {name:'八级',content_key:'subject30-t11-8'},
                // {name:'九级',content_key:'subject30-t11-9'},
            ]
        },
    ]
  },
  // 成人声乐
  subject_31:{
    tutoril:[
        // {
        //     title:'成人声乐考级曲目',
        //     tutorial_id:'tutorial_12',
        //     component:'subject31T12View',
        //     level:[
        //         {name:'一级',content_key:'subject31-t12-1'},
        //         {name:'二级',content_key:'subject31-t12-2'},
        //         {name:'三级',content_key:'subject31-t12-3'},
        //         {name:'四级',content_key:'subject31-t12-4'},
        //         {name:'五级',content_key:'subject31-t12-5'},
        //         {name:'六级',content_key:'subject31-t12-6'},
        //         {name:'七级',content_key:'subject31-t12-7'},
        //         {name:'八级',content_key:'subject31-t12-8'},
        //     ]
        // },
        {
            title:'新编成人声乐考级曲集',
            tutorial_id:'tutorial_50',
            component:'subject31T50View',
            level:[
                // {name:'一级',content_key:'subject31-t50-1'},
                // {name:'二级',content_key:'subject31-t50-2'},
                // {name:'三级',content_key:'subject31-t50-3'},
                // {name:'四级',content_key:'subject31-t50-4'},
                // {name:'五级',content_key:'subject31-t50-5'},
            ]
        }
    ]
  },
  // 歌唱爱好者
  subject_43:{
    tutoril:[
        {
            title:'中央音乐学院校外音乐水平考级曲目-歌唱爱好者考级',
            tutorial_id:'tutorial_59',
            component:'subject43T59View',
            level:[
                {name:'初级',content_key:'subject43-t59-1'},
                {name:'中级',content_key:'subject43-t59-2'},
                {name:'高级',content_key:'subject43-t59-3'},
                // {name:'四级',content_key:'subject31-t50-4'},
                // {name:'五级',content_key:'subject31-t50-5'},
            ]
        }
      ]
  },
  // 架子鼓
  subject_44:{
    tutoril:[
        {
            title:'中央音乐学院校外音乐水平考级曲目-架子鼓',
            tutorial_id:'tutorial_62',
            component:'subject44T62View',
            level:[
                {name:'一级',content_key:'subject44-t62-1'},
                {name:'二级',content_key:'subject44-t62-2'},
                {name:'三级',content_key:'subject44-t62-3'},
                {name:'四级',content_key:'subject44-t62-4'},
                {name:'五级',content_key:'subject44-t62-5'},
                {name:'六级',content_key:'subject44-t62-6'},
                {name:'七级',content_key:'subject44-t62-7'},
                {name:'八级',content_key:'subject44-t62-8'},
                {name:'九级',content_key:'subject44-t62-9'},
            ]
        }
      ]
  },
   // 大号
   subject_49:{
    tutoril:[
        {
            title:'中央音乐学院校外音乐水平考级曲目-大号',
            tutorial_id:'tutorial_65',
            component:'subject49T65View',
            level:[
                {name:'一级',content_key:'subject49-t65-1'},
                {name:'二级',content_key:'subject49-t65-2'},
                {name:'三级',content_key:'subject49-t65-3'},
                {name:'四级',content_key:'subject49-t65-4'},
                {name:'五级',content_key:'subject49-t65-5'},
                {name:'六级',content_key:'subject49-t65-6'},
                {name:'七级',content_key:'subject49-t65-7'},
                {name:'八级',content_key:'subject49-t65-8'},
                {name:'九级',content_key:'subject49-t65-9'}
            ]
        }
      ]
  },
   // 双排键电子琴（电子管风琴）
   subject_50:{
    tutoril:[
        {
            title:'中央音乐学院校外音乐水平考级曲目-双排键电子琴（电子管风琴）',
            tutorial_id:'tutorial_66',
            component:'subject50T66View',
            level:[
                {name:'一级',content_key:'subject50-t66-1'},
                {name:'二级',content_key:'subject50-t66-2'},
                {name:'三级',content_key:'subject50-t66-3'},
                {name:'四级',content_key:'subject50-t66-4'},
                {name:'五级',content_key:'subject50-t66-5'},
                {name:'六级',content_key:'subject50-t66-6'},
                {name:'七级',content_key:'subject50-t66-7'},
            ]
        }
      ]
  }
};
